export default __webpack_public_path__ + "static/media/BoxVitrine.0c4068a6.jpg";